(function() {
  define('bazemont/documents/uploader',['angular'], function() {
    'use strict';
    return angular.module('bazemontDocumentsUploader', []).component('bazemontDocumentsUploader', {
      templateUrl: '/assets/javascripts/bazemont/documents/uploader.html',
      bindings: {
        documents: '=',
        nbColumns: '@'
      },
      controller: [
        'TlhAwsService', 'TlhNotificationService', function(TlhAwsService, TlhNotificationService) {
          var getNextPosition, vm;
          vm = this;
          vm.uploadOptions = {
            multiple: true,
            fileMaxSize: 100 * 1000 * 1000,
            timestamp: true,
            preview: false
          };
          vm.uploadOptions.onFileInvalid = function(error, file) {
            return TlhNotificationService.warning({
              message: error,
              delay: 10000
            });
          };
          vm.uploadOptions.onFileUploaded = function(file) {
            return console.log('File ' + file.name + ' successfuly uploaded');
          };
          vm.uploadOptions.uploadComplete = function(uploadedFiles, allFiles) {
            var inputFile, _i, _len, _results;
            TlhNotificationService.success({
              message: 'Envoi terminé',
              replaceMessage: true
            });
            if (uploadedFiles.length > 0) {
              if (vm.documents == null) {
                vm.documents = [];
              }
              _results = [];
              for (_i = 0, _len = uploadedFiles.length; _i < _len; _i++) {
                inputFile = uploadedFiles[_i];
                _results.push(vm.documents.push({
                  isActive: true,
                  position: getNextPosition(),
                  file: {
                    url: inputFile.url,
                    filename: inputFile.name,
                    mimeType: inputFile.type,
                    size: inputFile.size
                  }
                }));
              }
              return _results;
            }
          };
          getNextPosition = function() {
            var document, position, _i, _len, _ref;
            position = 1;
            _ref = vm.documents;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
              document = _ref[_i];
              position++;
            }
            return position;
          };
          vm.uploadOptions.onFileError = function(error, file, message) {
            TlhNotificationService.error({
              message: message,
              replaceMessage: true
            });
            console.log('Error on file ' + file.name + ':');
            return console.log(error);
          };
          vm.uploadOptions.onFileAbort = function(file) {
            return console.log('File upload aborted for file ' + file.name);
          };
          vm.uploadOptions.onCancel = function() {
            return TlhNotificationService.warning({
              message: 'Envoi annulé',
              replaceMessage: true
            });
          };
          vm.uploadOptions.onLaunch = function() {
            return TlhNotificationService.info({
              message: 'Envoi en cours...',
              replaceMessage: true,
              delay: false
            });
          };
          TlhAwsService.getConfig().then(function(response) {
            return vm.uploadOptions.s3Config = response.config;
          });
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=uploader.js.map
;
